import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'spark-core-dx/components';

import { DashboardDomainContextProvider } from './DashboardDomainProvider';
import { DashboardSourceDataContextProvider } from './DashboardSourceDataProvider'; // ← keep legacy cache provider

import { VisualFormContextProvider } from './contexts/VisualFormContext';
import { CardLayoutContextProvider } from './contexts/CardLayoutContext';
import { VisualExportContextProvider } from './contexts/VisualExportContext';
import { FullscreenContextProvider } from './contexts/FullScreenContext';

// NEW engine data provider (adjust path/alias if needed)
import { DatasetDataProvider } from '../../engine/dataset';

const DashboardDomain = () => {
  // Defaults for the engine provider
  const appName = "CONVOKE";
  const apiName = "DashboardDataset";
  const operationType = "LoadDashboardDataset";
  const defaultRefreshIntervalMs = null; // no background refresh by default
  const autoInit = true;

  // Build baseItemsUri from window.configData (same pattern as BaseService)
  const baseItemsUri = `${window.configData.API_URIS[appName]}/Items`;


  return (
    <DatasetDataProvider
  baseItemsUri={baseItemsUri}
  appName={appName}
  apiName={apiName}
  operationType={operationType}
  defaultRefreshIntervalMs={defaultRefreshIntervalMs}
  autoInit={autoInit}
>
  <DashboardDomainContextProvider>
    <DashboardSourceDataContextProvider>
      <VisualFormContextProvider>
        <FullscreenContextProvider>
          <VisualExportContextProvider>
            <CardLayoutContextProvider>
              <Layout footer={false}>
                <Outlet />
              </Layout>
            </CardLayoutContextProvider>
          </VisualExportContextProvider>
        </FullscreenContextProvider>
      </VisualFormContextProvider>
    </DashboardSourceDataContextProvider>
  </DashboardDomainContextProvider>
</DatasetDataProvider>
  );
};

export default DashboardDomain;
